var stageUrl = process.env.VUE_APP_IMG_URL;
export default {
  name: 'share',
  data() {
    return {
      showBtn: true,
      showLoading: false,
      newSrc: '',
      showShareImg: false,
      showShareShop: false,
      detail: {},
      logo: ''
    };
  },
  methods: {
    drawCanvas(loding) {
      this.showBtn = false;
      this.showLoading = true;
      setTimeout(() => {
        this.$nextTick(() => {
          this.drawCanvasFun(loding);
        });
      }, 1000);
    },
    async drawCanvasFun(loding) {
      // 获取想要转换的 DOM 节点
      const dom = this.$refs.shareWarp;
      const box = window.getComputedStyle(dom);
      // DOM 节点计算后宽高
      const width = parseInt(box.width, 10);
      const height = parseInt(box.height, 10);
      // 获取像素比
      const scaleBy = this.DPR();
      // 创建自定义 canvas 元素
      var canvas = document.createElement('canvas');
      // 设定 canvas 元素属性宽高为 DOM 节点宽高 * 像素比
      canvas.width = width;
      canvas.height = height;
      canvas.id = 'can';
      // 设定 canvas css宽高为 DOM 节点宽高
      canvas.style.width = `${width / 100}rem`;
      canvas.style.height = `${height / 100}rem`;
      // 获取画笔
      const context = canvas.getContext('2d');
      // 将所有绘制内容放大像素比倍
      // context.scale(scaleBy, scaleBy);
      let x = width;
      let y = height;
      let that = this;
      return await html2canvas(dom, {
        backgroundColor: null,
        canvas,
        useCORS: true
      }).then(function (canvas) {
        that.newSrc = that.convertCanvasToImage(canvas, x, y).src;
        that.showLoading = false;
        that.showShareImg = true;
        that.showBtn = true;
      });
    },
    DPR() {
      if (window.devicePixelRatio && window.devicePixelRatio > 1) {
        return window.devicePixelRatio;
      }
      return 1;
    },
    convertCanvasToImage(canvas, x, y) {
      let image = new Image();
      image.setAttribute("crossOrigin", 'Anonymous');
      image.width = x;
      image.height = y;
      image.src = canvas.toDataURL("image/png");
      return image;
    },
    getDetailByCode() {
      let a = {
        filters: [[{
          alias: "autoId",
          compt: "editinput",
          express: "===",
          id: 28,
          range: null,
          val: this.$route.query.code
        }]],
        model: 0
      };
      let singleform = {};
      singleform.deptId = this.$route.query.fid || '151066';
      singleform.formId = '112720';
      singleform.searchStr = encodeURI(JSON.stringify(a));
      this.$api.singleadvanceSearch(singleform).then(res => {
        this.setData(res.dataList[0].formIdValueData, 'name');
      });
    },
    setData(data, type) {
      if (type == 'name') {
        this.detail.name = this.getValInFormData(data, 'antiqueName');
        let img = this.getValInFormData(data, 'thumbPath', 'img');
        this.getUrlByObjectId(img);
        this.detail.description = this.getValInFormData(data, 'description');
        console.log(this.detail);
      }
    },
    getUrlByObjectId(objectId, type) {
      this.$api.getUrlByObjectId(objectId).then(res => {
        let img = res.download ? res.download.replace('http://d0.ananas.chaoxing.com/', 'https://museum.chaoxing.com/') : '';
        type == 'logo' ? this.logo = img : this.detail.img = img;
      });
    },
    getValInFormData(data, id, type) {
      if (!data[id] || !data[id].groupValues[0] || !data[id].groupValues[0].values[0].length) {
        return '';
      }
      let target;
      if (type && type == 'img') {
        if (!data[id].groupValues[0].values[0][0]) return;
        target = data[id].groupValues[0].values[0][0].objectId;
      } else {
        target = type ? data[id].groupValues[0].values[0][0][type] : data[id].groupValues[0].values[0][0].val;
      }
      return target;
    },
    getLogo() {
      let singleform = {
        limit: 100,
        page: 1
      };
      singleform.fid = this.$route.query.fid || '151066';
      singleform.formId = '112706';
      this.$api.singleformList(singleform).then(res => {
        let data = res.data[0];
        let logoObjectId = this.getConfigInFormData(data.formData, 'logo', 'img');
        this.getUrlByObjectId(logoObjectId, 'logo');
      });
    },
    getConfigInFormData(data, id, type) {
      let target = data.find(d => {
        return d.alias == id;
      });
      if (!target) return '';
      target = target.values[0];
      target.file = target.objectId;
      return type ? target.file : target.val;
    }
  },
  created() {
    let list = ['html2canvas.js'];
    list.map(item => {
      let oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      oScript.src = `js/3d/${item}`;
      document.body.appendChild(oScript);
    });
  },
  mounted() {
    this.getDetailByCode();
    this.getLogo();
  },
  computed: {}
};